import { apiClient } from '_app'
import { ApiResponse, ImportBranchDto } from 'dtos'

export const getImportBranches = () =>
  apiClient.get<ApiResponse<ImportBranchDto[]>>('/api/import-branches').then(response => response.data)
